module.exports = __webpack_public_path__ + "img/profile-style-img3.74941a19.png";